namespace Portico.Models {
    export class ChangePasswordRequestModel {
        public userName: string;
        public password: string;
        public newPassword: string;
        public portalId: string;
    }
}